import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.white,
    width: '100%',
    alignSelf: 'center',
    maxWidth: 768,
    borderRadius: theme.borderRadii.xl,
    maxHeight: '95%',
    overflow: 'hidden',
  },
  // react-native-modal insets its content by 5% of the device width per side;
  // a fixed inset gives a wide dialog the screen edges back on large tablets.
  wideModal: {
    margin: theme.spacings.lg,
  },
  containerWide: {
    maxWidth: 1200,
  },
  headerNeutral: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes.xl,
    padding: theme.spacings.md,
    flex: 1,
  },
  headerDanger: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes.xl,
    padding: theme.spacings.md,
    color: theme.colors.white,
    flex: 1,
  },
  buttonRow: {
    padding: theme.spacings.md,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleRowNeutral: {
    backgroundColor: theme.colors.grey,
  },
  titleRowDanger: {
    backgroundColor: theme.colors.red,
  },
  closeXButton: {
    padding: theme.spacings.md,
  },
});
